export class LowPowerVideoDetector {
  constructor(el, poster) {
    this.el = el;
    this.poster = poster;

    this.promise;
    this.play();
  }

  get loaded() {
    return this.el.networkState === 1;
  }

  get isAppleTouch() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform,
    );
  }

  play() {
    if (this.loaded && this.el.paused) {
      return this.el.play().finally(() => {
        const timeout = this.isAppleTouch ? 300 : 0;

        setTimeout(() => {
          this.poster.style.opacity = 0;
        }, timeout);
      });
    }

    return Promise.resolve();
  }

  handleLoadedData() {
    this.promise = this.play();
  }

  handleSuspend() {
    if (this.promise) {
      this.promise.then(() => {
        this.play();
      });
    } else {
      this.play();
    }
  }

  addEventListeners() {
    this.el.addEventListener('loadeddata', e => {
      this.handleLoadedData(e);
    });

    this.el.addEventListener('suspend', e => {
      this.handleSuspend(e);
    });
  }
}

export function addBackgroundVideoListeners() {
  const el = document.getElementById('bg-vid');
  const poster = document.getElementById('bg-vid-poster');

  if (!(el && poster)) {
    return;
  }

  const detector = new LowPowerVideoDetector(el, poster);
  detector.addEventListeners();
}
